import React, { forwardRef } from "react";
import PropTypes from "prop-types";
import cx from "classnames";

import { ColorSelection } from "../ColorSelection";

import styles from "./ProductTile.scss";

const ProductTileColors = forwardRef(
  ({ colors, customClass, ...restProps }, ref) => {
    return (
      <>
        <div
          ref={ref}
          className={cx(styles.colors, customClass)}
          {...restProps}
        >
          <ColorSelection interactive={false} vertical>
            {colors.map((color) => (
              <ColorSelection.Item
                key={`${color.name}-${color.hash}${
                  color.isLight ? "-light" : ""
                }`}
                color={`#${color.hash}`}
                isLight={color.isLight}
              >
                {color.name}
              </ColorSelection.Item>
            ))}
          </ColorSelection>
        </div>
      </>
    );
  }
);

ProductTileColors.displayName = "ProductTile.Colors";

ProductTileColors.propTypes = {
  colors: PropTypes.arrayOf(
    PropTypes.shape({
      hash: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      isLight: PropTypes.bool,
    })
  ),
  customClass: PropTypes.string,
};

ProductTileColors.defaultProps = {
  colors: [],
  customClass: undefined,
};

export default ProductTileColors;
